import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const PaidStatus = () => {
  return (
    <div className="flex items-center justify-center gap-1.5 rounded-full border border-solid border-[rgba(0,0,0,0.12)] bg-success-100 px-2.5">
      <Icon icon="checkbox-circle-mono" color="success" shade={700} size={16} />
      <Typography variant="p" size="small" color="neutral-700">
        Invoice paid in full
      </Typography>
    </div>
  );
};

export default PaidStatus;
